import { chakra } from '@chakra-ui/react';
import { SelectionStateEnum } from '@monetize/types/app';
import { MCenter, MCheckbox, MFlex, MText } from '../Monetize';

interface TransactionApplicationTableSelectRowProps {
  checkedState: SelectionStateEnum;
  isDisabled?: boolean;
  onToggleSelectAll: () => void;
  /**
   * Number of grid cells the "Apply All" label spans (every cell after the
   * checkbox). Defaults to 6 for the full table.
   */
  applyAllColSpan?: number;
}

export const TransactionApplicationTableSelectRow = ({
  checkedState,
  isDisabled,
  onToggleSelectAll,
  applyAllColSpan = 6,
}: TransactionApplicationTableSelectRowProps) => {
  return (
    <>
      <MCenter>
        <MCheckbox
          isChecked={checkedState === SelectionStateEnum.ALL}
          isIndeterminate={checkedState === SelectionStateEnum.SOME}
          isDisabled={isDisabled}
          id={'applications-apply-all'}
          onChange={() => onToggleSelectAll()}
        />
      </MCenter>
      <MFlex align="center" gridColumn={`span ${applyAllColSpan}`}>
        <chakra.label htmlFor={`applications-apply-all`} fontWeight="400" m="0">
          <MText>Apply All</MText>
        </chakra.label>
      </MFlex>
    </>
  );
};
